export var ActionIconSizes;
(function (ActionIconSizes) {
    ActionIconSizes["small"] = "small";
    ActionIconSizes["medium"] = "medium";
    ActionIconSizes["large"] = "large";
})(ActionIconSizes || (ActionIconSizes = {}));
//# sourceMappingURL=constants.js.map